import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";

export default function TableItem({
  apple,
  handleEdit,
  handleSold,
  handleDelete,
  handleCheckboxChange,
  checkedItems,
}) {
  const [showKey, setShowKey] = useState(false); // State to toggle key visibility

  function timeSince(date) {
    var seconds = Math.floor((new Date() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago";
  }

  const copied = () => {
    toast.success("Text Copied", {
      position: "bottom-center",
      autoClose: 500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });
  };

  return (
    <tr key={apple.id}>
      <td className="id" style={{ display: "none" }}>
        {apple.id}
      </td>
      <td className="customer_name">{apple.id}</td>
      <td className="email">{apple.owner}</td>

      {/* API Key Column */}
      <td className="email">
        {showKey ? (
          apple.key
        ) : (
          <span style={{ fontStyle: "italic", color: "#999" }}>Hidden</span>
        )}
        <button
          className="btn btn-sm btn-link"
          onClick={() => setShowKey(!showKey)}
        >
          {showKey ? "Hide" : "Show"}
        </button>
      </td>

      <td className="date">{timeSince(new Date(apple.created_at))}</td>
      <td className="status">
        <span
          className={`badge text-uppercase ${
            apple.is_active === true || apple.is_active === 1
              ? "badge-soft-success"
              : "badge-soft-warning"
          }`}
          style={{ fontSize: 14 }}
        >
          {apple.is_active === true || apple.is_active === 1
            ? "Active"
            : "Disabled"}
        </span>
      </td>
      <td>
        <div className="d-flex gap-2">
          <div className="edit">
            <button
              className="btn btn-md btn-success edit-item-btn"
              data-bs-toggle="modal"
              data-bs-target="#showModal"
              onClick={() => handleEdit(apple)}
            >
              <i className="ri-edit-line align-bottom"></i>
            </button>
          </div>

          <div className="sold">
            <button
              className="btn btn-warning btn-md edit-item-btn"
              onClick={() => handleSold(apple.id)}
            >
              <i className="ri-money-dollar-circle-line align-bottom"></i>
            </button>
          </div>
          <div className="copy">
            <div
              className="btn btn-md edit-item-btn"
              style={{ backgroundColor: "#0b9b42", color: "#fff" }}
            >
              <CopyToClipboard text={apple.key} onCopy={copied}>
                <i className="ri-clipboard-line align-bottom"></i>
              </CopyToClipboard>
            </div>
          </div>
          <div className="remove">
            <button
              className="btn btn-danger btn-md remove-item-btn"
              onClick={() => handleDelete(apple.id)}
            >
              <i className="ri-delete-bin-6-line align-bottom"></i>
            </button>
          </div>
        </div>
      </td>
    </tr>
  );
}
